function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  d: "M14.6139 2.5C16.8167 2.5 18.6523 4.33567 18.6523 6.53846C18.6523 8.74126 16.8167 10.5769 14.6139 10.5769C12.4111 10.5769 10.5754 8.74126 10.5754 6.53846C10.5754 4.33567 12.4111 2.68357 14.6139 2.5ZM14.6139 8.74126C15.8988 8.74126 16.8167 7.82343 16.8167 6.53846C16.8167 5.2535 15.8988 4.33567 14.6139 4.33567C13.3289 4.33567 12.4111 5.43706 12.4111 6.53846C12.4111 7.82343 13.3289 8.74126 14.6139 8.74126Z",
  fill: "white"
});

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  d: "M45.2982 2.5C43.0954 2.5 41.2598 4.33567 41.2598 6.53846C41.2598 8.74126 43.0954 10.5769 45.2982 10.5769C47.501 10.5769 49.3367 8.74126 49.3367 6.53846C49.3367 4.33567 47.501 2.68357 45.2982 2.5ZM45.2982 8.74126C44.0133 8.74126 43.0954 7.82343 43.0954 6.53846C43.0954 5.2535 44.0133 4.33567 45.2982 4.33567C46.5832 4.33567 47.501 5.43706 47.501 6.53846C47.501 7.82343 46.5832 8.74126 45.2982 8.74126Z",
  fill: "white"
});

var _ref4 =
/*#__PURE__*/
React.createElement("path", {
  d: "M47.7197 26.7307H48.5274C53.4343 26.7307 57.412 30.7085 57.412 35.6153C57.412 40.5222 53.4343 44.5 48.5274 44.5H47.7197V26.7307Z",
  fill: "white"
});

var _ref5 =
/*#__PURE__*/
React.createElement("path", {
  d: "M12.1924 26.7307H11.3847C6.47785 26.7307 2.50007 30.7085 2.50007 35.6153C2.50007 40.5222 6.47785 44.5 11.3847 44.5H12.1924V26.7307Z",
  fill: "white"
});

var _ref6 =
/*#__PURE__*/
React.createElement("path", {
  d: "M29.9521 12.1924C38.0287 12.1929 47.7197 16.2321 47.7197 29.1543V46.9229C47.4505 49.6151 43.52 54.9986 29.9521 54.999V55L29.9512 54.999L29.9502 55V54.999C16.3823 54.9986 12.4518 49.6151 12.1826 46.9229V29.1543C12.1826 16.2321 21.8736 12.1929 29.9502 12.1924H29.9521Z",
  fill: "#65A30D"
});

var _ref7 =
/*#__PURE__*/
React.createElement("path", {
  d: "M15.4143 18.444C14.8004 19.2434 14.2571 20.1319 13.7991 21.1158V10.5768H15.4143V18.444Z",
  fill: "white"
});

var _ref8 =
/*#__PURE__*/
React.createElement("path", {
  d: "M44.4927 18.4434C45.1067 19.243 45.6498 20.132 46.1079 21.1162V10.5771H44.4927V18.4434Z",
  fill: "white"
});

var _ref9 =
/*#__PURE__*/
React.createElement("path", {
  d: "M7.95264 43.9392C8.8355 44.3056 9.78998 44.5317 10.7896 44.5945C13.0494 46.2903 16.1826 47.6707 20.2417 47.6707V49.3464C14.4371 49.3464 10.3673 46.6246 7.95264 43.9392Z",
  fill: "white"
});

var _ref10 =
/*#__PURE__*/
React.createElement("path", {
  d: "M24.3014 44.5001C26.5042 44.5001 28.3398 46.3358 28.3398 48.5386C28.3398 50.7414 26.5042 52.5771 24.3014 52.5771C22.0986 52.5771 20.2629 50.7414 20.2629 48.5386C20.2629 46.3358 22.0986 44.6837 24.3014 44.5001ZM24.3014 50.7414C25.5863 50.7414 26.5042 49.8236 26.5042 48.5386C26.5042 47.2536 25.5863 46.3358 24.3014 46.3358C23.0164 46.3358 22.0986 47.4372 22.0986 48.5386C22.0986 49.8236 23.0164 50.7414 24.3014 50.7414Z",
  fill: "white"
});

var _ref11 =
/*#__PURE__*/
React.createElement("path", {
  d: "M38.1839 26.0017C38.1839 26.0017 33.0455 26.0017 23.6495 26.0017C14.8408 26.0017 15.428 33.043 15.428 33.043C15.428 40.9833 22.3282 40.5338 22.1814 40.5338H38.3308C38.3308 40.5338 44.4969 40.384 44.4969 33.043C44.4969 25.7021 38.1839 26.0017 38.1839 26.0017ZM21.4474 35.8895C19.9792 35.8895 18.8047 34.691 18.8047 33.1929C18.8047 31.6947 19.9792 30.4962 21.4474 30.4962C22.9155 30.646 24.09 31.6947 24.09 33.1929C24.09 34.691 22.9155 35.8895 21.4474 35.8895ZM29.9625 38.1368C26.1453 38.1368 26.7326 34.5412 26.7326 34.5412H33.1923C33.1923 34.5412 34.0732 38.1368 29.9625 38.1368ZM38.3308 35.8895C36.8626 35.8895 35.6881 34.691 35.6881 33.1929C35.6881 31.6947 36.8626 30.4962 38.3308 30.4962C39.7989 30.646 40.9734 31.6947 40.9734 33.1929C40.9734 34.691 39.7989 35.8895 38.3308 35.8895Z",
  fill: "white"
});

var SvgChatBotAiDark = function SvgChatBotAiDark(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgChatBotAiDark, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/chat_bot_ai_dark.6bc4c076.svg";
export { ForwardRef as ReactComponent };